// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  chronieUrl: 'https://test-chronie.pl/',
  dobryAgentUrl: 'https://test.dobryagent.pl',
  apkUrl:'https://test-apk.asfpremium.pl',
  asf24: 'https://test-1.asf24.pl'
};

export const src = {
  production: 'https://test.asf360.pl/'
};
export const srcFileManager = {
  production: 'https://cdn.asf360.pl',
  sharedFileLink: 'https://cdn.asf360.pl/api/shared-file/'
};

export const linkAffiliate = {
  production: ['https://chronie.pl/ubezpieczenia/nnw-szkolne?agentCode=',
    'https://chronie.pl/ubezpieczenia/nnw-dla-studenta?agentCode=',
    'https://chronie.pl/ubezpieczenia/oc-pilota-drona?agentCode=',
    'https://chronie.pl/ubezpieczenia/oc-operatora-drona?agentCode=']
};
